import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const FuluDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-teal-50 flex flex-col">
      <div className="flex-grow flex flex-col items-center py-12 px-4">
        <div className="w-full max-w-4xl">
          <button
            onClick={() => navigate('/fulu')}
            className="flex items-center text-green-800 mb-8 hover:text-green-600 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            返回符箓列表
          </button>

          <div className="bg-white rounded-2xl shadow-xl border-2 border-green-200 overflow-hidden">
            <div className="bg-gradient-to-r from-green-500 to-teal-500 py-6 text-center">
              <h1 className="text-3xl font-bold text-white font-serif tracking-widest">
                学 业 符 箓
              </h1>
              <p className="text-white/80 mt-2">学业进步，考试顺利</p>
            </div>

            <div className="p-8">
              <div className="flex justify-center mb-8">
                <img
                  src="/images/fulu/fulu_xueye1.png"
                  alt="学业符箓"
                  className="max-w-md rounded-lg shadow-lg"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>

              <div className="space-y-6 text-gray-700 leading-relaxed">
                <div className="bg-green-50 rounded-xl p-6 border border-green-100">
                  <h3 className="text-lg font-bold text-green-900 mb-3">符箓说明</h3>
                  <p>此符为学业符箓，适用于学生考试、升学、考研、考公等各种学业相关事项。</p>
                </div>

                <div className="bg-green-50 rounded-xl p-6 border border-green-100">
                  <h3 className="text-lg font-bold text-green-900 mb-3">使用方法</h3>
                  <ul className="list-disc list-inside space-y-2">
                    <li>选择吉日吉时焚香请符</li>
                    <li>将符箓供奉于文昌位或书房</li>
                    <li>每日诚心叩拜，祈求学业进步</li>
                    <li>考试期间可将符箓随身携带或置于考场</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FuluDetail;
